import React from "react";
import { HomeLogoBgRemove } from "utils/images";

export default function Logo({ logo1, logo2, logo3, width }) {
  return (
    <section>
      <div className="flex flex-col items-center">
        <img
          src={HomeLogoBgRemove}
          alt=""
          className={`${width?.logo1 ? width?.logo1 : "w-36"}`}
        />
        {/* <img
          src={logo2}
          alt=""
          className={`${width?.logo2 ? width?.logo2 : "w-44"}`}
        />
        <img
          src={logo3}
          alt=""
          className={`${width?.logo3 ? width?.logo3 : "w-60"}`}
        /> */}
      </div>
    </section>
  );
}
